/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Email_PlaceholderInputs */

const en_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const fr_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const de_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const it_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const ru_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта`)
};

const es_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

const zh_cn2_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const ja_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール`)
};

const hi_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल`)
};

const pt_pt2_team_manager_email_placeholder = /** @type {(inputs: Team_Manager_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Team_Manager_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_email_placeholder = /** @type {((inputs?: Team_Manager_Email_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Email_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_email_placeholder(inputs)
	if (locale === "de") return de_team_manager_email_placeholder(inputs)
	if (locale === "it") return it_team_manager_email_placeholder(inputs)
	if (locale === "ru") return ru_team_manager_email_placeholder(inputs)
	if (locale === "es") return es_team_manager_email_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_email_placeholder(inputs)
	if (locale === "ja") return ja_team_manager_email_placeholder(inputs)
	if (locale === "hi") return hi_team_manager_email_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_email_placeholder(inputs)
	return en_team_manager_email_placeholder(inputs)
});